export default "__VITE_ASSET__7c92a8ae__"